import { observable, computed, makeObservable } from "mobx";
import { ColorOption } from "../models/ColorOptionModel";
import BreakpointStore from "../stores/BreakpointStore";

export default class ColorsStore {
  constructor() {
    makeObservable(this);
  }
  @observable breakpoint: BreakpointStore = new BreakpointStore();
  @observable colorOptions?: ColorOption[];
  @observable colorOption: ColorOption;
  @observable displayIndex: number;

  fetchColorOptions(colorOptions: ColorOption[]) {
    this.colorOptions = colorOptions;
    this.displayIndex = 0;
    this.backfillColourImagesIfRequired();
    const defaultOptions = this.colorOptions.filter((colorOption) => {
      return colorOption.isDefault;
    });
    this.colorOption = defaultOptions[0] || this.colorOptions[0];
  }

  onColorOptionSelected(colorOption: ColorOption) {
    if (colorOption !== this.colorOption) {
      this.colorOption = colorOption;
      this.displayIndex = 0;
    }
  }

  backfillColourImagesIfRequired = () => {
    this.colorOptions &&
      this.colorOptions.forEach((colourOption, index) => {
        if (colourOption.imageFront && colourOption.imageRear && colourOption.colourImages.length === 0) {
          colourOption.colourImages.unshift(colourOption.imageFront, colourOption.imageRear);
        }
      });
  };

  navigateToImage = (direction: string) => {
    if (direction === "Back") {
      if (this.displayIndex) {
          this.displayIndex--;
      }
    } else if (direction === "Next") {
      if (this.displayIndex < this.colorOption.colourImages.length - 1) {
          this.displayIndex++;
      }
    }
  };

  navigateToIndex = (index: number) => {
    if (this.displayIndex !== index) {
        this.displayIndex = index;
    }
  }

  @computed get navPosition() {
    return this.displayIndex * (-100/this.colorOption.colourImages.length);
  }

  getNavigationState = (direction: string) => {
    if (direction === "Back") {
      return !this.displayIndex;
    } else if (direction === "Next") {
      return this.displayIndex < this.colorOption.colourImages.length - 1 ? false : true;
    }
  };
}
